module.exports = __webpack_public_path__ + "img/logo_thantai_pc.29e4baa8.png";